import React, { Component } from 'react';
import { render } from 'react-dom';
import ReactDOM from 'react-dom'
import ReactModal from 'react-modal';
import Request from './lib/utils/requests.es6.js';

const customModalStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        padding               : "0",
        transform             : 'translate(-50%, -50%)',
    }
};

const dialogStyle = {
    width: THEME_GRANITE ? undefined : '400px',
    height: THEME_GRANITE ? undefined : '200px',
};

const buttonDivStyle = {
    display: 'flex',
    justifyContent: 'center',
};

class DebugDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            status: 'NOT-INITIALIZED',
            message: '',
            port: null
        };
        this.onClick = this.onClick.bind(this);
        this.onClose = this.onClose.bind(this);
        this.checkStatus = this.checkStatus.bind(this);
        this.debug = this.debug.bind(this);
    }

    onClick() {
        this.setState({
            open: true
        });
    }

    onClose() {
        this.setState({
            open: false
        });
    }

    checkStatus() {
        const url = jsRoutes.controllers.ApiV1.getUnitCommands(this.props.unitId).url;
        Request.getJson(url, (response) => {
            let tasks = response.response.scheduled;
            tasks = tasks.filter(x => x.task === 'debug');
            let status = tasks[0].status;
            if (status === 'connected') {
                window.clearInterval(this.timer);
                this.setState({
                    status: 'READY'
                });
            }
        }, (response) => {
        });
    }

    deleteCommand(commandId) {
        const url = jsRoutes.controllers.ApiV1.deleteUnitCommand(this.props.unitId, commandId).url;
        Request.delete(url, (response) => {
            return true;
        }, (response) => {
            return false;
        });
    }

    debug() {
        this.setState({
            status: 'INITIALIZING'
        });

        Request.postJson(jsRoutes.controllers.ApiV1.createUnitCommand(this.props.unitId).url, { occurrence: 'daily', task: 'debug' }, (response) => {
            this.setState({
                port: response.response.port
            });
            this.timer = window.setInterval(this.checkStatus, 5000);
        }, () => {
            this.setState({
                status: 'ERROR',
                message: 'Error registering command'
            });
        });
    }

    render() {
        return <div>
            <ReactModal
                contentLabel="Remote debug"
                closeTimeoutMS={150}
                isOpen={this.state.open}
                shouldCloseOnOverlayClick={true}
                style={customModalStyles}>
                <div style={dialogStyle} className="modal-content" id="mediaItem-dialog">
                    <div className="modal-header">
                        <h4 className="modal-title">Remote debug</h4>
                        <button type="button" className="close" onClick={this.onClose}>
                            <span aria-hidden="true">&times;</span>
                            <span className="sr-only">Close</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {this.state.status === 'NOT-INITIALIZED' ? <div>
                                <span>Click on the "start" button to initialize the debug session.</span>
                            </div> : <div />}

                        {this.state.status === 'INITIALIZING' ? <div>
                            {THEME_GRANITE ? <div className="fa-2x d-flex justify-content-center my-5">
                                <span className="fa fa-spinner fa-spin"/>
                            </div> : <img alt="loading" src="/assets/images/loading-32.gif" />}
                        </div> : <div />}

                        {this.state.status === 'READY' ? <div>
                            The unit is ready, open an SSH client (in Windows, use PuTTY) and connect using the following command:<br/>
                            <pre className={THEME_GRANITE ? "jumbotron mt-3 mb-0 p-2" : ""}><b>ssh -p {this.state.port} root@debug.mobitec.eu</b></pre>
                        </div> : <div />}

                        {this.state.status === 'ERROR' ? <div>
                            <span>{this.state.message}</span>
                        </div> : <div />}
                    </div>
                    {this.state.status === 'NOT-INITIALIZED' ? <div className="modal-footer" style={buttonDivStyle}>
                        <button className={THEME_GRANITE ? "btn btn-primary" : ""} onClick={this.debug}>Start</button>
                    </div> : <div />}
                </div>
            </ReactModal>
        </div>
    }
}

let $container = null;

window.openDebugDialog = (unitId) => {
    if ($container) {
        ReactDOM.unmountComponentAtNode($container[0]);
    } else {
        $container = $("<div />").appendTo("body");
    }
    render(
        <DebugDialog unitId={unitId}/>,
        $container[0]
    );
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/debugDialog.jsx